import { render, staticRenderFns } from "./PerformanceComparisonProgressBarDouble.vue?vue&type=template&id=b30109c4&scoped=true"
import script from "./PerformanceComparisonProgressBarDouble.vue?vue&type=script&lang=js"
export * from "./PerformanceComparisonProgressBarDouble.vue?vue&type=script&lang=js"
import style0 from "./PerformanceComparisonProgressBarDouble.vue?vue&type=style&index=0&id=b30109c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30109c4",
  null
  
)

export default component.exports